import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import useHttpRequests from "../../hooks/useHttpRequests";
import { setFacilityId } from "../../reducers/selectedValues";
import { MuiComboBoxWithSearch } from "../uiControls/muiComboBoxWithSearch";
import { FormControl, CircularProgress, Backdrop } from "@mui/material";

export const SelectFacility = () => {
  const [facilities, setFacilities] = useState([]);
  const facilityDispatch = useDispatch();

  const { isLoading, sendRequest: fetchFacilities } = useHttpRequests();

  useEffect(() => {
    const getMenuResponse = (resObj) => {
      if (!resObj || !resObj.isSuccess || resObj.errorResponse) {
        console.log("Facilities fetch response returns error");
        return;
      }
      let myFacilities = [];
      resObj["facilities"].forEach((obj, index) => {
        myFacilities.push({
          id: obj["facilityKey"],
          label: obj["name"],
          key: index,
        });
      });

      setFacilities(myFacilities);
      facilityDispatch(setFacilityId(myFacilities[0]?.["id"]));
    };
    fetchFacilities(
      { url: "Facilities/Active", method: "GET", header: true },
      getMenuResponse
    );
  }, []);

  const handleSelectChange = (id, name, value) => {
    if (value) {
      facilityDispatch(setFacilityId(value));
    }
  };

  return (
    <div>
      <Backdrop className="backDrop" open={isLoading}>
        <CircularProgress color="inherit" />
        <p>Please wait...</p>
      </Backdrop>
      <div style={{ display: "flex", gap: "10px" }}>
        <label
          style={{
            fontSize: "18px",
            fontWeight: "normal",
            padding: "10px 0px 0px 0px",
            color: "#3a8ddd",
          }}
        >
          Facility:
        </label>
        <FormControl
          id={"form_facilityId"}
          name={"form_facilityId"}
          fullWidth
          size="small"
        >
          <MuiComboBoxWithSearch
            id={"facilityId"}
            list={facilities}
            onChange={handleSelectChange}
          />
        </FormControl>
      </div>
    </div>
  );
};
